import { render, staticRenderFns } from "./LogisticsOrderDetail.vue?vue&type=template&id=77130167&scoped=true&"
import script from "./LogisticsOrderDetail.vue?vue&type=script&lang=js&"
export * from "./LogisticsOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./LogisticsOrderDetail.vue?vue&type=style&index=0&id=77130167&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77130167",
  null
  
)

export default component.exports